import * as Yup from 'yup';

const validationSchema = Yup.object({
  accounts: Yup.array().required().min(1, 'Please select at least one account.')
});

export default validationSchema;
